import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from "@angular/core";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { RouterOutlet } from "@angular/router";
import { ContentComponent } from "../content";

@Component({
  selector: "app-screen-coordinator",
  templateUrl: "../content.html",
  styleUrls: ["../content.less"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatProgressSpinner, RouterOutlet],
})
export class CoordinatorComponent extends ContentComponent implements OnInit, OnDestroy {
  public ngOnInit(): void {
    this.applicationService.updateTitle(ContentComponent.TITLE);
    this.applicationService.subscribe(this.id);
  }

  public ngOnDestroy(): void {
    this.applicationService.unsubscribe(this.id);
  }
}
